<div class="faq-container">
  @let questionsState = expandedQuestions(); @for (question of component()?.faq_questions;
  track question.id) { @if (question.id) {
  <div class="faq-question">
    <span>{{ question.question }}</span>
    <button (click)="toggleQuestion(question.id)">
      @if (questionsState[question.id]) {
      <app-icon name="chevron-up"></app-icon>
      } @else {
      <app-icon name="chevron-down"></app-icon>
      }
    </button>
  </div>

  <div
    class="faq-answer"
    [innerHTML]="question.answer"
    [ngClass]="{
      'faq-answer__expanded': questionsState[question.id],
      'faq-answer__collapsed': !questionsState[question.id]
    }"
  ></div>

  <div class="faq-separator"></div>
  } }
</div>
